import { render, staticRenderFns } from "./AttendanceViewV2.vue?vue&type=template&id=1c4b230b&scoped=true"
import script from "./AttendanceViewV2.vue?vue&type=script&lang=js"
export * from "./AttendanceViewV2.vue?vue&type=script&lang=js"
import style0 from "./AttendanceViewV2.vue?vue&type=style&index=0&id=1c4b230b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b230b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4b230b')) {
      api.createRecord('1c4b230b', component.options)
    } else {
      api.reload('1c4b230b', component.options)
    }
    module.hot.accept("./AttendanceViewV2.vue?vue&type=template&id=1c4b230b&scoped=true", function () {
      api.rerender('1c4b230b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/AttendanceViewV2.vue"
export default component.exports